module.exports = __webpack_public_path__ + "img/hat-3.9c142ff1.svg";